var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"ootf-entry",attrs:{"to":{
    name: 'MinisterBiography',
    params: { slug: _vm.minister.slug }
  }}},[_c('MinisterPhoto',{attrs:{"photo":_vm.minister.details.photo}}),_c('MinisterNameplate',{attrs:{"minister":_vm.minister}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }